import { Component, OnInit } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription, interval } from 'rxjs';
import { ApiService } from '../services/contratos/contratos.service';
import { AppModule } from '../app.module';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CarregaService } from '../services/carrega_file/carrega.service';
import moment from 'moment';
import { format } from 'date-fns';

@Component({
    selector: 'app-diretos-flow',
    templateUrl: './diretos-flow.component.html',
    styleUrls: ['./diretos-flow.component.css'],
    standalone: false
})
export class DiretosFlowComponent implements OnInit {

  subscription: Subscription | undefined;
  items: any[] = [];
  itemsAntigo: any[] = [];
  fornecedores: any[] = [];
  posicao: any[] = [];
  sortColumn: string = '';
  sortNumber: number = 0;
  sortDirection: number = 1;
  dataLoaded = true;
  filtroDataInicio: Date = new Date();
  filtroDataTermino: Date = new Date();
  itemsFiltrados: any[] = [];
  searchText: string = '';
  items2: any[] = [ /* Seus itens aqui */];
  private searchTextSubject = new Subject<string>();
  private searchTextSubscription!: Subscription;
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlSalva: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  query2: string = 'veiculos_lab_Karrara'
  queryPosicao: string = 'positionLOTS';
  // query5: string = 'tipos_Veiculos_Karrara';
  queryPositionLots: string = 'positionLOTS'
  queryContainer: string = 'items_Excel_Container';
  data: any;
  editMode!: boolean[];
  informationMode!: boolean[];
  address!: string;
  DataAtual: Date = new Date();
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: ''
  };
  dialogOpen!: boolean;
  dialogAddViagem!: boolean;
  carriers!: any[];
  places!: any[];
  transportadora!: string[];
  locais!: string[];
  datePipe: any;

  progManual: string[] = [
    'Rumo Norte EMBALAGEM'
  ];
  selectedDescription!: string;
  Transportadoras!: string;
  listaTransportadoras!: any[];
  dataInvertida: string = '';
  fornecedores1!: any[];
  fornecedores2!: any[];
  fornecedores3!: any[];
  fornecedores4!: any[];
  fornecedoresDescarga1!: any[];
  fornecedoresDescarga2!: any[];
  fornecedoresDescarga3!: any[];
  fornecedoresDescarga4!: any[];
  tipoVeiculo!: any[];
  listaVeiculo1!: any[];
  datadescarga!: string | null;
  tipoVeiculos: any;
  isLoading: boolean = true;
  posicaoCarros!: any[];
  veiculosLab: any;
  referenceDate!: string;
  itemsContainersPrev!: any[];



  constructor(private dynamoDBService: ApiService, public dialog: MatDialog, private http: HttpClient, private carregaService: CarregaService) {
    this.editMode = [];
    this.informationMode = [];
  }

  async ngOnInit() {

    await this.update()
    this.isLoading = false;
    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.update()
      this.isLoading = false;
    });
  }

  async update() {
    await this.getVeiculosLab();
    await this.getItemsFromDynamoDB();
    await this.getPositionLotsFromDynamoDB();
    await this.armazenarLatitudeEmItems();

    this.isLoading = false;
  }

  async deleteItem(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamoDBService.deleteItem(ID, this.urlSalva, this.queryContainer).subscribe(
        async response => {
          // setTimeout(() => {
          await this.ngOnInit();
          this.isLoading = false;
        },
        error => {
        }
      );
    }
  }


  isISODateValid(dateString: string) {
    // Tenta criar um objeto Date a partir da string
    const date = new Date(dateString);
    // Verifica se o objeto Date é um objeto de data válido e não é NaN
    return !isNaN(date.getTime());
  }

  cancel(): void {
    this.dialogOpen = false;
    this.dialogAddViagem = false;
  }

  editDialog(item: any): void {
    // console.log(item)
    // console.log(typeof item.Janela)
    // console.log(item.Janela)
    this.item = {...item}
    // const date = new Date(item.Janela);
    // date.setHours(date.getHours() - 3);
    // const formattedDate = date.toISOString();
    // console.log(formattedDate);

    // const dataHoraString = item.Janela;
    item.dataJanela = item.Janela.slice(0, 10);
    item.horaJanela = item.Janela.slice(11, 16); // "00:00"

    this.item.ID = item.ID;
    this.item.dataJanela = item.dataJanela;
    this.item.horaJanela = item.horaJanela;
    this.item.dataFalta = item.dataFalta;
    this.item.destino = item.destino;
    this.item.destinoApos = item.destinoApos;
    this.item.fatura = item.fatura;
    this.item.idContainer = item.idContainer;
    this.item.invoiceRemarks = item.invoiceRemarks;
    this.item.itemCritico = item.itemCritico;
    this.item.Janela = item.Janela;
    this.item.lastupdate = item.lastupdate;
    this.item.linner = item.linner;
    this.item.num_NF1 = item.num_NF1;
    this.item.processo = item.processo;
    this.item.quantidadeMU = item.quantidadeMU;
    this.item.tableName = item.tableName;
    this.item.terminalAtual = item.terminalAtual;
    this.item.terminalOrigem = item.terminalOrigem;
    this.item.transportador = item.transportador;
    this.item.plate = item.plate;
    this.item.danificado = item.danificado;
    this.dialogOpen = true;
  }

  async salvar(item: any): Promise<void> {
    this.isLoading = true;
    this.dialogOpen = false;
    const dataHoraString = `${item.dataJanela}T${item.horaJanela}:00.000Z`;
    const dataHoraString2 = `${item.dataJanela}T${item.horaJanela}:00`;
    // console.log(dataHoraString)
    const dataHora = new Date(dataHoraString2);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = [];
    body = [{
      ...item, // Mantém as chaves existentes
      "ID": item.ID,
      "plate": item.plate,
      "danificado": item.danificado,
      "Janela": dataHoraString,
      "jan1": dataHora.toISOString(),
      // Adicione outros campos conforme necessário
    }];
    // console.log(body)
    await this.dynamoDBService.salvar(body, this.queryContainer, this.urlSalva).subscribe(async response => {
      // Atualiza o item no banco de dados com sucesso
      // await this.ngOnInit();
      console.log('Dados salvos com sucesso!')
      await this.update();
      this.isLoading = false;
    }, error => {
      console.log(error);
      // Lidar com o erro ao atualizar o item no banco de dados
    });
  }

  async converterStringParaData(dataString: string): Promise<String> {
    // Dividir a string em partes
    const partes = dataString.split(/[\s/:]+/);
    // Converter as partes para números
    const [dia, mes, ano, hora, minuto, segundo] = partes.map(Number);
    // Criar um objeto Date
    const data = new Date(ano, mes - 1, dia, hora, minuto, segundo);
    const newDateString = format(data, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
    return newDateString;
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getItemsFromDynamoDB(): Promise<void> {
    this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsVolumesAltos("items_Excel_Container", this.urlConsultaCompactada, 'All', "Janela", this.referenceDate, 30)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            // this.items = items.filter(item => {
            //   return item.Finalizada != true
            // })
            this.items = items
            .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True");
            // console.log(this.items)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getVeiculosLab(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query2, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculosLab = items
              .map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            // Filtra os itens com chave 'DataBordo' indefinida
            // console.log(this.veiculosLab)

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getPositionLotsFromDynamoDB(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.queryPositionLots, this.urlConsulta, 'All')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.posicaoCarros = items
              .map(item => ({ ...item, checked: false }));
            // console.log(this.posicaoCarros)
            this.posicaoCarros.some(position => {
              const vin = position.VIN;
              const matchingVeic = this.veiculosLab.find((obj: { [x: string]: any; }) => obj['vincode'] == vin);
              if (matchingVeic) {
                // console.log(matchingVeic)
                // position['placa'] = matchingVeic['placa'];
                position['modelo'] = matchingVeic['modelo'];
                return false; // Retorna false para continuar iterando
              } else {
                return true; // Retorna true para sair do loop
              }
            });

            // console.log(this.posicaoCarros)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  armazenarLatitudeEmItems() {
    //console.log("entrou em armazenarLatitudeEmItems")
    for (let i = 0; i < this.items.length; i++) {
      const plate = this.items[i]['plate'];
      const matchingPosicao = this.posicaoCarros.find(obj => obj['placa'] === plate);
      // console.log(matchingPosicao)
      if (matchingPosicao) {
        this.items[i]['position'] = matchingPosicao['Latitude'] + ' , ' + matchingPosicao['Longitude'];
        this.items[i]['Latitude'] = matchingPosicao['Latitude'];
        this.items[i]['Longitude'] = matchingPosicao['Longitude'];
        this.items[i]['localizacao'] = matchingPosicao['Endereco'];
        this.items[i]['data_atualizacao'] = new Date(matchingPosicao['data_atualizacao']);
        this.items[i]['DataBordo'] = new Date(matchingPosicao['PositionDateTime']);
        // console.log(matchingPosicao)

      }
      if (this.items[i]['DataBordo'] === undefined) {
        this.items[i]['Conexao'] = false;
      } else {
        this.DataAtual = new Date();
        var outraData = new Date(this.items[i]['DataBordo']);
        // Obtém o deslocamento de fuso horário em minutos
        var offset = outraData.getTimezoneOffset();
        // Ajusta a data subtraindo o deslocamento de fuso horário em minutos
        outraData.setMinutes(outraData.getMinutes() - offset);
        // console.log(outraData)
        if (new Date(outraData.setHours(outraData.getHours() + 1)) > this.DataAtual) {
          this.items[i]['Conexao'] = true;
        } else {
          this.items[i]['Conexao'] = false;
        }
      }
    }
  }

  async completaViagem(item: any) {
    const confirmacao = window.confirm("Tem certeza que deseja finalizar esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      const body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        "Finalizada": true,
      }];

      //nao usa a query, ele manda a time table no item
      await this.dynamoDBService.salvar(body, this.queryContainer, this.urlSalva).subscribe(async response => {
        // Atualiza o item no banco de dados com sucesso
        await this.update();
        this.isLoading = false;
      }, error => {
        console.log(error);
        // Lidar com o erro ao atualizar o item no banco de dados
      });
    }
  }

  onStartNodeServer() {
    this.carregaService.startNodeServer().subscribe(() => {
      // console.log('Servidor Node.js iniciado com sucesso!');
    }, (error) => {
      console.error('Erro ao iniciar o servidor Node.js:', error);
    });
    // this.carregaService.startNodeServer()
  }

}
